var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "relative overflow-hidden preview-root",
    style: {
      'background-color': _vm.skin.page_background_color
    }
  }, [_c('confetti', {
    staticClass: "absolute-fill",
    staticStyle: {
      "z-index": "3"
    },
    attrs: {
      "effect": _vm.skin.open_effect,
      "active": !!_vm.skin.open_effect
    }
  }), _vm.skin.music ? _c('div', {
    staticClass: "absolute d-flex align-end",
    staticStyle: {
      "bottom": "5%",
      "right": "5%",
      "z-index": "2",
      "width": "18%"
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "100%",
      "color": "grey"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiMusic)
    }
  })], 1) : _vm._e(), _c('card-background', {
    staticStyle: {
      "z-index": "0"
    },
    attrs: {
      "src": _vm.skin.page_background_img,
      "scale": _vm.bgScale
    }
  }), _c('div', {
    staticClass: "fill-height",
    staticStyle: {
      "z-index": "1",
      "padding": "5%"
    }
  }, [_c('envelope', {
    key: "env",
    ref: "env",
    staticClass: "fill-height",
    attrs: {
      "skin": _vm.skin,
      "from": _vm.from,
      "to": _vm.to,
      "aspect-ratio": _vm.isStandaloneGroupVideo ? 16 / 9 : 5 / 7
    },
    scopedSlots: _vm._u([_vm.card ? {
      key: "default",
      fn: function (_ref) {
        var w = _ref.w;
        return [_vm.isStandaloneGroupVideo ? _c('v-card', {
          attrs: {
            "color": "black"
          }
        }, [_c('v-responsive', {
          attrs: {
            "aspect-ratio": 16 / 9,
            "content-class": "d-flex justify-center align-center"
          }
        }, [_c('v-btn', {
          staticClass: "absolute",
          style: {
            transform: `scale(${.0025 * w + .25})`
          },
          attrs: {
            "fab": "",
            "color": "primary"
          }
        }, [_c('v-icon', {
          attrs: {
            "x-large": ""
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiPlay)
          }
        })], 1)], 1)], 1) : _c('card-preview', {
          key: "card",
          staticClass: "v-card v-sheet",
          attrs: {
            "mode": _vm.mode || 'view',
            "card": _vm.card,
            "is-card-owner": true,
            "width": w
          }
        })];
      }
    } : null], null, true)
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }